import { call, put, select, takeEvery } from 'redux-saga/effects';

import { SELECT_DEALER } from 'constants/ActionTypes';
import { PATH } from 'constants/RoutesConstants';
import { scopeToPage } from 'modules/app/sagas/utils';
import { SELECT_GROUP } from 'modules/groups/actionTypes';
import { fetchAlterableQuestions } from 'modules/questionModels/actions';
import { getBaseParameters } from 'modules/selfServices/selectors/config';

import { checkSelectedGroup } from './extras.dashboard';

const refreshDashboard = (group = false) =>
  function* refresh() {
    const params = yield select(state => getBaseParameters(state, group));
    if (params.groupId || params.dealerId) {
      yield put(fetchAlterableQuestions(params));
    }
  };

function* initializeDealerDashboard() {
  const refreshFn = refreshDashboard();
  yield call(refreshFn);
  yield takeEvery(SELECT_DEALER, refreshFn);
}

function* initializeGroupDashboard() {
  const refreshFn = refreshDashboard(true);
  yield call(checkSelectedGroup);
  yield call(refreshFn);
  yield takeEvery([SELECT_DEALER, SELECT_GROUP], refreshFn);
}

export default function* QuestionsDashboardSaga() {
  yield scopeToPage([PATH.GROUP_QUESTION_MODEL_DASHBOARD], initializeGroupDashboard);
  yield scopeToPage([PATH.DEALER_QUESTION_MODEL_DASHBOARD], initializeDealerDashboard);
}
